import { render, staticRenderFns } from "./tab_resolution.vue?vue&type=template&id=dc5a19f2&scoped=true&"
import script from "./tab_resolution.vue?vue&type=script&lang=js&"
export * from "./tab_resolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5a19f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc5a19f2')) {
      api.createRecord('dc5a19f2', component.options)
    } else {
      api.reload('dc5a19f2', component.options)
    }
    module.hot.accept("./tab_resolution.vue?vue&type=template&id=dc5a19f2&scoped=true&", function () {
      api.rerender('dc5a19f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/tabs/resolution/tab_resolution.vue"
export default component.exports